import React, { useState } from 'react'
import { Col, Row } from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import WebCamList from './_list';
import WebCamForm from './_form';

const WebCam = () => {
    const [loading] = useState(false)
    const [viewMode, setViewMode] = useState("LIST")
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    return (<>
        {loading && showLoader()}

        {
            viewMode === "LIST"  ? <> 
                <Row>
                    <Col md="12">
                        <div className="d-flex align-items-center">
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                            </div> 
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col> 
                        <WebCamList setForm={ setForm }/> 
                    </Col>
                </Row>
            </> : <Row>
                <Col> 
                    <WebCamForm 
                        setForm={ setForm } 
                        updateItem={ setItem } 
                        item={ item } 
                        editMode={ editMode } 
                    />
                </Col>
            </Row>

        }
    </>)
}

export default WebCam
